// extracted by mini-css-extract-plugin
export default {"wrapper":"AddYear_wrapper__FvE6I","form":"AddYear_form__dgq5D","actions":"AddYear_actions__v0E2r","addBtn":"AddYear_addBtn__HirdA"};